import { getOperationAST } from 'graphql';

import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { AppDocument } from 'src/graphql/actions/apps/app.query';
import { AppsDocument } from 'src/graphql/actions/apps/apps.query';
import { AppProtectionsDocument } from 'src/graphql/actions/apps/appProtections.query';
import { AppActiveProtectionIdsDocument } from 'src/graphql/actions/apps/appActiveProtectionIds.query';
import { AppProtectionAssuranceSummaryDocument } from 'src/graphql/actions/apps/appProtectionAssuranceSummary.query';
import { ProtectionBeneficiariesDocument } from 'src/graphql/actions/apps/protectionBeneficiaries.query';

const REFETCH_DOCUMENTS = [
  AppProtectionsDocument,
  ProtectionBeneficiariesDocument,
  AppActiveProtectionIdsDocument,
  AppProtectionAssuranceSummaryDocument,
  AppsDocument,
  AppDocument,
];

export const refetchAppProtections = () => {
  const { cache } = client;

  cache.evict({ fieldName: 'appProtections', broadcast: false });
  cache.evict({ fieldName: 'appProtectionAssuranceSummary', broadcast: false });
  cache.evict({ fieldName: 'apps', broadcast: false });
  cache.evict({ fieldName: 'app', broadcast: false });

  cache.gc();

  const activeQueryNames = new Set(Array.from(client.getObservableQueries('active'), (query) => query.queryName));

  client.refetchQueries({
    include: REFETCH_DOCUMENTS.filter((document) => activeQueryNames.has(getOperationAST(document)?.name?.value)),
  });
};
